import { timePeriodToDays, type TimePeriodUnit } from "../../../ui/time-period-select/time-period-utils.ts";

export type ProvisionPreset = "30" | "90" | "custom";

export type CustomProvision = {
  amount: number;
  unit: TimePeriodUnit;
};

/** Returns ISO date string (`YYYY-MM-DD`) for confirmation based on provision preset (legacy AssignManager). */
export function computeConfirmationDate(
  provisionPreset: ProvisionPreset,
  custom?: CustomProvision,
): string {
  let days: number;
  if (provisionPreset === "custom") {
    const amount = custom?.amount ?? 1;
    const unit = custom?.unit ?? "month";
    days = timePeriodToDays(amount, unit);
  } else {
    days = Number(provisionPreset);
  }

  const today = new Date();
  today.setDate(today.getDate() + days);
  return today.toISOString().split("T")[0];
}
